import { render, staticRenderFns } from "./TablaCortes.vue?vue&type=template&id=b565d55c&scoped=true"
import script from "./TablaCortes.vue?vue&type=script&lang=js"
export * from "./TablaCortes.vue?vue&type=script&lang=js"
import style0 from "./TablaCortes.vue?vue&type=style&index=0&id=b565d55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b565d55c",
  null
  
)

export default component.exports